import React from 'react'
import AppHeader from '../../atoms/app-header/app-header'

import BannerHome from '../banner-home/banner-home'
import NavMenu from '../nav-menu/nav-menu'
import useMediaQuery from '../../../utils/useMediaQuery'

import './home-content.scss'
import PrebioticosSection from '../prebioticos-section/prebioticos-section'
import BannerShop from '../../molecules/bannerShop/bannerShop'
import FrequentQuestions from '../frequents-questions/frequent-questions'
import SectionHygiene from '../section-hygiene/section-hygiene'
import Footer from '../../../shared/components/molecules/footer/footer'
import FormAndVideoSection from '../form-and-video-section/form-and-video-section'
import { LOCALE } from '../../../constants/activity-constants'
const showBuy = ['es-CL','es-PR'].includes(LOCALE) ? false : true
const HomeContent = () => {
  const isMobile = useMediaQuery()
  const [commondModal, setCommondModal] = React.useState(null)
  console.log('showBuy', showBuy)
  return (
    <div className="f-home-content">
      {commondModal}
      <div className="f-home-content__nav-container">
        <NavMenu isMobile={isMobile} canBuy={showBuy} />
      </div>
      <div className="f-home-content__container">
        <AppHeader />
        <section id="proDefense">
          <BannerHome canBuy={showBuy} />
        </section>
        <section id="prebiotics">
          <PrebioticosSection isMobile={isMobile} />
        </section>
        <section id="rutine">
          <SectionHygiene />
        </section>
        <section id="questions">
          <FrequentQuestions />
        </section>
        <section>
          <FormAndVideoSection isMobile={isMobile} />
        </section>
        {showBuy && (
          <section id="buy">
            <BannerShop />
          </section>
        )}
        <Footer setCommondModal={setCommondModal} mobile={isMobile} />
      </div>
    </div>
  )
}

export default HomeContent
